import { type FC } from "react";

import { type ColorVariant, MomentButton, colorVariantOptions } from "@moment/ui";

import { Popover } from "../../../PopoverV2";
import { TagColor } from "./TagColor";
import { TagColorChoice } from "./TagColorChoice";

export const TagColorSelector: FC<{
	selectedColor: ColorVariant;
	onColorChange: (color: ColorVariant) => void;
}> = ({ selectedColor, onColorChange }) => {
	return (
		<Popover.Root>
			<Popover.Trigger asChild>
				<MomentButton className="h-8 w-8" level="tertiary" size="md">
					<TagColor color={selectedColor} />
				</MomentButton>
			</Popover.Trigger>
			<Popover.Portal>
				<Popover.Content>
					<div className="grid grid-cols-4 gap-2">
						{colorVariantOptions.map((color) => (
							<TagColorChoice
								key={color}
								color={color}
								label={color}
								selected={selectedColor === color}
								onClick={onColorChange}
							/>
						))}
					</div>
				</Popover.Content>
			</Popover.Portal>
		</Popover.Root>
	);
};
